import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueApexCharts from 'vue-apexcharts'
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'
import VueMoment from 'vue-moment'
import ticket from './components/Ticket.vue';
import imageDialog from './components/ImageDialog.vue';
import storno from './components/Storno.vue';
import aedTextField from './components/aedTextField.vue';
import aedCheckbox from './components/aedCheckbox.vue';
import aedNumberField from './components/aedNumberField.vue';
import aedSelect from './components/aedSelect.vue';
import aedCountrySelect from './components/aedCountrySelect.vue';
import aedDateRange from './components/aedDateRange.vue';
import aedDatePicker from './components/aedDatePicker.vue';
import aedAutoDatePicker from './components/aedAutoDatePicker.vue';
import aedContactSelector from './components/aedContactSelector.vue';
import aedLabelSelect from './components/aedLabelSelect.vue';
import aedGenericSearch from './components/aedGenericSearch.vue';
import aedOrganisation from './components/aedOrganisation.vue';
import aedVolumeField from './components/aedVolumeField.vue';
import aedUpdateDialog from './components/aedUpdateDialog.vue';
import aedTableLegend from './components/aedTableLegend.vue';
import aedMap from './components/aedMap.vue';
import aedExportIcons from './components/aedExportIcons.vue'


import vuetify from './plugins/vuetify';
import CountryFlag from 'vue-country-flag'
import { ValidationProvider } from 'vee-validate';
import { get } from 'lodash';
import VueGlobalVar from 'vue-global-var';
import helperMixin from './mixins/helper';
import '@mdi/font/css/materialdesignicons.css';




Vue.config.productionTip = false;
Vue.use(VueApexCharts, VueAxios, axios, VueMoment, moment)
Vue.component('apexchart', VueApexCharts)
Vue.component('country-flag', CountryFlag)
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ticket', ticket);
Vue.component('storno', storno);
Vue.component('image-dialog', imageDialog);
Vue.component('aed-text-field', aedTextField);
Vue.component('aed-checkbox', aedCheckbox);
Vue.component('aed-number-field', aedNumberField);
Vue.component('aed-select', aedSelect);
Vue.component('aed-country-select', aedCountrySelect);
Vue.component('aed-date-range', aedDateRange);
Vue.component('aed-date-picker', aedDatePicker);
Vue.component('aed-date-picker-auto', aedAutoDatePicker);
Vue.component('aed-organisation', aedOrganisation);
Vue.component('aed-contact-selector', aedContactSelector);
Vue.component('aed-generic-search', aedGenericSearch);
Vue.component('aed-label-select', aedLabelSelect);
Vue.component('aed-volume-field', aedVolumeField);
Vue.component('aed-update-dialog', aedUpdateDialog);
Vue.component('aed-table-legend', aedTableLegend);
Vue.component('aed-map', aedMap);
Vue.component('aed-export-icons', aedExportIcons);



Vue.use(VueGlobalVar, {
    globals: {
        $menuItems: [
            { icon: 'mdi-home', text: 'STR_HOME', route: "home",  active: true },
            { icon: 'mdi-view-dashboard', text: 'STR_DASHBOARD', route: "dashboard", active: false },
            { icon: 'mdi-package-variant', text: 'STR_ERF', route: "newShipment", active: false },
            { icon: 'mdi-clipboard-list', text: 'STR_ZL2',  route: "loadingList", active: false },
            { icon: 'mdi-sticker-text', text: 'STR_TICKET', route: "ticket", active: false },
            { icon: 'mdi-crosshairs-gps', text: 'STR_RESEARCH', route: "track", active: true, },
            { icon: 'mdi-clipboard-account', text: 'STR_CONTACTS', route: "contacts", active: false },
            { icon: 'mdi-glass-fragile', text: 'STR_MNU_PSD', route: "damageReport", active: false },
            { icon: 'mdi-truck-alert', text: 'STR_MNU_PSDQ', route: "damages", active: false },
            { icon: 'mdi-recycle', text: 'STR_MWBSTAT', route: "returnableContainer", active: false },
        ],


        $languageItems: [
            { code: 'de', title: 'Deutsch', flag: "de" },
            { code: 'en', title: 'English', flag: "gb" },
            { code: 'it', title: 'Italiano', flag: 'it' },
            { code: 'hu', title: 'Magyar nyelv', flag: "hu" },
            { code: 'cs', title: 'Czech', flag: "cz" },
            { code: 'sk', title: 'Slovak', flag: 'sk' },
            { code: 'hr', title: 'Hrvatski', flag: "hr" },
            { code: 'sl', title: 'Slovenscina', flag: "si" },
            { code: 'ro', title: 'Romana', flag: 'ro' },
            { code: 'bg', title: 'Bulgarski', flag: "bg" }

        ],
        $keyfigures: [

            {
                color: 'orange',
                icon: 'mdi-package-variant',
                strTable: 'common',
                strLabel: 'STR_SEND',
                amount: 0,
                visible: true,


            },
            {
                color: 'indigo lighten-1',
                icon: 'mdi-scale',
                strTable: 'common',
                strLabel: 'STR_WEIGHT',
                amount: 0,
                visible: true,


            },
            {
                color: 'green',
                icon: 'mdi-keyboard-return',
                strTable: 'statovrw',
                strLabel: 'STR_RETURNS',
                amount: 0,
                visible: true,


            },
            {
                color: 'red',
                icon: 'mdi-alert',
                strTable: 'logon2',
                strLabel: 'STR_DAMAGED',
                amount: 0,
                visible: true,


            }]


    },
});
if (process.env.NODE_ENV === 'production') {

    console.log = function () { };
    console.info = function () { };
    console.error = function () { };
    console.warn = function () { };
    console.debug = function () { };
    console.table = function () { };
}

Vue.mixin(helperMixin);

/**
 * Axios default to include Session Cookie
 */
axios.defaults.withCredentials = true;
/**
 * Axios request interceptor.
 * Sets default headers for every outgoing request.
 */
axios.interceptors.request.use(config => {
    if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json; charset=UTF-8';
    }
    return config;
});
/**
* Axios response interceptor.
* Handles session expiration, JSON validation, and error response messages.
*/
let logonErrorCount = 0;
const LOGON_ERROR_THRESHOLD = 3;
const LOGON_URL_FRAGMENT = 'logon';
axios.interceptors.response.use(

    response => {
        /**
     * Handles successful HTTP responses (status 200).
     * - Verifies JSON structure
     * - Checks for custom session expiration status (-999)
     *
     * @param {Object} response - Axios response object
     * @returns {Object} response - The unmodified response if valid
     * @throws Will dispatch an error and throw if JSON is invalid
     */

        if (response.status === 200) {
            try {
                if (typeof response.data === 'string') {
                    JSON.parse(response.data);
                }
            } catch (e) {
                const errorMessage = `Invalid JSON response from ${response.config.method.toUpperCase()} ${response.config.url}: ${e}`;
                store.dispatch("showMessage", { type: "Error", text: errorMessage });
                throw new Error(errorMessage);
            }

            if (response.data.status && response.data.status === -999) {
                console.log("session expired i will rest user now");
                store.dispatch("showMessage", { type: "Error", text: response.data.msg });
                store.commit('resetUser');
                if (router.currentRoute.path !== '/') {
                    router.push('/');
                }
            } else {
                return response;
            }
        }
    },
    /**
   * Handles failed HTTP responses and displays appropriate error messages.
   *
   * @param {Object} error - Axios error object
   * @returns {Promise} Rejected promise with the error
   */
    error => {



        const url = (error.config && error.config.url) ? error.config.url : '';
        const status = (error.response && error.response.status) ? error.response.status : 0;
        const params = new URLSearchParams((error.config && error.config.params) ? error.config.params : {});


        const errorMessage = `Error calling ${url}: `;

        // Prüfen ob es ein Keep-Alive-Ping ist (logon ohne load=1)
        const isLogonPing = url.includes(LOGON_URL_FRAGMENT) && params.get('load') !== '1';

        if (isLogonPing) {
            if (status >= 500 || status === 0) {
                logonErrorCount++;
            } else {
                logonErrorCount = 0;
            }

            if (logonErrorCount < LOGON_ERROR_THRESHOLD) {
                // Ignorieren
                return Promise.reject(error);
            } else {
                store.dispatch("showMessage", {
                    type: "Error",
                    text: `Keep-Alive Error (${logonErrorCount}x): ${errorMessage} ${status}`
                });
                return Promise.reject(error);
            }
        }

        // Standard-Fehlerbehandlung inkl. logon mit load=1
        switch (status) {
            case 400:
                store.dispatch("showMessage", { type: "Error", text: errorMessage + "Bad Request" });
                break;
            case 401:
                store.dispatch("showMessage", { type: "Error", text: errorMessage + "Unauthorized" });
                if (router.currentRoute.path !== '/') {
                    router.push('/');
                }
                break;
            case 403:
                store.dispatch("showMessage", { type: "Error", text: errorMessage + "Forbidden" });
                break;
            case 404:
                store.dispatch("showMessage", { type: "Error", text: errorMessage + "Not Found" });
                break;
            case 500:
                store.dispatch("showMessage", { type: "Error", text: errorMessage + "Internal Server Error" });
                break;
            case 502:
                store.dispatch("showMessage", { type: "Error", text: errorMessage + "Bad Gateway" });
                break;
            default:
                store.dispatch("showMessage", { type: "Error", text: errorMessage + "An error occurred" });
        }

        return Promise.reject(error);
    }
);

const app = new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
    beforeCreate() {
        this.$store.dispatch("checkUser");
        this.$store.dispatch("loadPermissions");
    },
    created() {
        // Call the action immediately when the component is created
        // Set an interval to call the action every 20 seconds
        this.intervalId = setInterval(() => {
            this.$store.dispatch("checkUser");
        }, 20000);
    },
    beforeDestroy() {
        // Clear the interval when the component is destroyed to prevent memory leaks
        clearInterval(this.intervalId);
    },

}).$mount('#app')

